<section>
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div class="filter_search_opt">
          <a href="javascript:void(0);" (click)="openFilterSearch($event)">Search Property<i
              class="ml-2 ti-menu"></i></a>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-8 col-md-12 col-sm-12">
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <div class="filter-fl"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 col-md-6" *ngFor="let property of properties">
            <app-property-card [data]="property"></app-property-card>
          </div>
        </div>

      </div>
      <!-- property Sidebar -->
      <div class="col-lg-4 col-md-12 col-sm-12">
        <div class="page-sidebar hideonmbile">
          <div class="agent-widget">
            <app-property-search></app-property-search>
          </div>
        </div>
        <!-- <div class="page-sidebar"> -->
        <div class="page-sidebar simple-sidebar sm-sidebar" id="filter_search"
          [ngStyle]="{ display: sidebar ? 'block' : 'none' }">
          <div class="search-sidebar_header">
            <!-- Agent detail-->

            <h4 class="ssh_heading">Close Filter</h4>
            <button (click)="closeFilterSearch($event)" class="w3-bar-item w3-button w3-large">
              <i class="ti-close"></i>
            </button>
          </div>

          <!-- Agent Detail -->
          <div class="agent-widget">
            <app-property-search></app-property-search>
          </div>
        </div>
      </div>
      <!-- Sidebar End -->
    </div>
  </div>
</section>
<style>
  .simple-sidebar {
    padding: 0;
    border: none;
    border-radius: 0;
  }

  .simple-sidebar .search-sidebar_header {
    padding: 20px;
  }

  .simple-sidebar .agent-widget {
    border-radius: 0;
    border-width: 0;
  }
</style>